export default "__VITE_ASSET__DNwsCU6e__"